import template from './ko-field-input-json.html';

class JSONInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.valid = ko.observable(true);
		this.help_text = ko.observable(params.help_text);

		// Initialize textInput with either $input value or default_value
		const initialValue = this.$input() || params.default_value;
		this.textInput = ko.observable(initialValue ? JSON.stringify(initialValue, null, 2) : '');
		
		// Subscribe to text input changes to validate JSON
		this.textInput.subscribe((nv) => {
			let valid;
			let obj;
			try {
				obj = JSON.parse(nv);
				valid = true;
			} catch (err) {
				valid = false;
			}

			this.valid(valid);

			if (valid)
				this.$input(obj);
		});

		// Subscribe to $input changes to update the text input
		this.$input.subscribe((newValue) => {
			if (newValue !== undefined && newValue !== null)
			{
				try {
					const jsonStr = JSON.stringify(newValue, null, 2);
					// Only update if the stringified value is different to avoid loops
					if (jsonStr !== this.textInput())
						this.textInput(jsonStr);

				} catch (err) {
					this.valid(false);
				}
			}
			else
				this.textInput('');
		});
	}
}

export default {
	name: 'ko-field-input-json',
	viewModel: JSONInputComponentVM,
	module_type: 'ko',
	template: template
} 